import { render, staticRenderFns } from "./AstaChatInput.vue?vue&type=template&id=5738ba73&scoped=true&"
import script from "./AstaChatInput.vue?vue&type=script&lang=js&"
export * from "./AstaChatInput.vue?vue&type=script&lang=js&"
import style0 from "./AstaChatInput.vue?vue&type=style&index=0&id=5738ba73&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5738ba73",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5738ba73')) {
      api.createRecord('5738ba73', component.options)
    } else {
      api.reload('5738ba73', component.options)
    }
    module.hot.accept("./AstaChatInput.vue?vue&type=template&id=5738ba73&scoped=true&", function () {
      api.rerender('5738ba73', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AstaChatInput.vue"
export default component.exports